import { render, staticRenderFns } from "./YBMessage.vue?vue&type=template&id=03bc58fd&scoped=true&"
import script from "./YBMessage.vue?vue&type=script&lang=js&"
export * from "./YBMessage.vue?vue&type=script&lang=js&"
import style0 from "./YBMessage.vue?vue&type=style&index=0&id=03bc58fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bc58fd",
  null
  
)

export default component.exports